import { FC } from "react";
import { THeadedSectionContentProps } from "./HeadedSection.config";

export const HeadedSectionContent: FC<THeadedSectionContentProps> = ({ children }) => (
  <div
    data-component="HeadedSectionContent"
    className="flex flex-col space-y-4 p-4 border border-solid border-component-headed-section-base"
  >
    { children }
  </div>
);
